import moment from "moment";

const validChars = ["/", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

export const formatTextToDDMMYYYY = (input) => {

    const lastChar = input[input.length-1];

    if (validChars.includes(lastChar)) {
        return input;
    }

    return input.slice(0, input.length-1);

}

const MONTH_LABELS = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];

const PARSE_FORMATS = [
    "MM/YYYY",
    "M/YYYY",
    "DD/MM/YYYY",
    "D/M/YYYY",
    "DD/MM/YY",
    "YYYY-MM-DD",
    "YYYY/MM/DD",
    "YYYY",
];

const parseFlexibleDate = (input) => {
    if (input === null || input === undefined || input === "") return null;
    if (input instanceof Date) {
        const m = moment(input);
        return m.isValid() ? m : null;
    }
    const str = String(input).trim();
    if (!str) return null;
    const strict = moment(str, PARSE_FORMATS, true);
    if (strict.isValid()) return strict;
    const iso = moment(str, moment.ISO_8601, true);
    if (iso.isValid()) return iso;
    const loose = moment(str);
    return loose.isValid() ? loose : null;
};

export const handleTimePeriod = (fromDate, toDate, present, excludeMonths) => {

    const from = parseFlexibleDate(fromDate);
    if (!from) return "-";

    const fromLabel = excludeMonths
        ? from.format("YYYY")
        : `${MONTH_LABELS[from.month()]} ${from.format("YYYY")}`;

    if (present) return `${fromLabel} - Present`;

    const to = parseFlexibleDate(toDate);
    if (!to) return `${fromLabel} -`;

    const toLabel = excludeMonths
        ? to.format("YYYY")
        : `${MONTH_LABELS[to.month()]} ${to.format("YYYY")}`;

    return `${fromLabel} - ${toLabel}`;

}

export const formatUploadedDate = (date) => {

    let dd = moment(date).date(),
        mm = moment(date).month()+1,
        yy = moment(date).year();

    if (dd < 10) {
        dd = "0"+dd;
    }

    if (mm < 10) {
        mm = "0"+mm;
    }

    return `${dd}/${mm}/${yy}`;

}

export const latestFirst = (a, b) => {

    const dateA = parseFlexibleDate(a.fromDate);
    const dateB = parseFlexibleDate(b.fromDate);

    if (dateA && dateB) {
        if (dateA.isAfter(dateB)) return -1;
        if (dateA.isBefore(dateB)) return 1;
    }

    return 0;

}

// CV parsing emits "-/-/-" (visas/certificates) and "-/-" (roles/education) as
// "no date" placeholders. Treat those - and anything else with no digit in it -
// as missing, so the CV never renders "exp. -/-/-".
export const isRealDate = (value) => {

    if (!value) return false;

    return /[0-9]/.test(String(value));

}

// Formats a date of birth as DD/MM/YYYY. Accepts a Date, an ISO string (as
// stored in the DB), or an already-formatted DD/MM/YYYY string, so it is safe
// to call on a value that may have been formatted already (idempotent).
// Returns "" for a missing/unparseable value rather than today's date.
export const readDob = (dob) => {

    if (!dob) return "";

    const parsed = dob instanceof Date
        ? moment(dob)
        : moment(String(dob), [moment.ISO_8601, "DD/MM/YYYY", "D/M/YYYY", "YYYY-MM-DD"], true);

    return parsed.isValid() ? parsed.format("DD/MM/YYYY") : "";

}